export const processStyles = {
    listItem: {
        bgcolor: "background.paper",
        mb: 1,
        borderRadius: 1,
        border: "1px solid #e0e0e0",
    },
};
